import React, {useRef, useState} from 'react';
import { connect } from 'react-redux';
import { withStyles, Tooltip, IconButton, Typography } from '@material-ui/core';
import { hasPermission, hasAtLeastOnePermission, createHistory, parseURL } from '../../sc-utilities';
import { Redirect } from 'react-router-dom';
import { FindInPage } from '@material-ui/icons';
import ColliTypeList from './ColliTypeList';

const styles = theme => ({
    root: {
        width: `98.9%`,
        height: 'auto',
        paddingTop: theme.spacing(),
        paddingLeft: theme.spacing(),
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            margin: 0,
            width: '100%'
        }
    },
    progressBarr: {
        width: '100%',
        height: 5
    }
});

const ColliType = props => {
    const tableRef = useRef();
    const { classes, columns, translations, permissions, location } = props;

    const warehouseObj = location.state
    const [redirectOptions, setRedirectOptions] = useState({ redirect: false, search: null, redirectPath: '' });
    let searchParams = parseURL(window.location.search);

    let visible = columns && columns['ColliType'];

    const isValid = data => {
        return (data !== null && data !== undefined)
    };

    let tableColumns = [
        {
            title: translations["action"] || "Action", field: 'ColliTypeID',
            hidden: visible ? visible['ColliTypeID'] : false,
            cellStyle: { minWidth: 100, maxWidth: 100 },
            filtering: false,
            render: rowData => <>
                {hasPermission(permissions, 'colli_type_load') ?
                    <Tooltip key={`Edit-${rowData.ColliTypeID}`} title={translations["colli_type_details"] || "Colli type details"}>
                        <IconButton
                            id={`edit_colli_type_${rowData.ColliTypeID}`}
                            component='div'
                            onClick={(event) => redirectHandler(`/colli-type/edit`, `?colliTypeID=${rowData.ColliTypeID}`)}
                        >
                            <FindInPage />
                        </IconButton>
                    </Tooltip>
                    : null
                }
            </>
        },
        {
            title: translations["name"] || 'Name', field: 'Name',
            hidden: visible ? visible['Name'] : false,
            defaultFilter: searchParams && searchParams.ColliTypeName ? decodeURIComponent(searchParams.ColliTypeName) : '',
            filtering: true,
            render: rowData => {
                return <Typography variant={'caption'}>{rowData.Name ? rowData.Name : translations['short_not_assigned'] || 'n/a'}</Typography>;
            }
        },
        {
            title: translations["width"] || 'Width', field: 'Width',
            hidden: visible ? visible['Width'] : false,
            filtering: true,
            render: rowData => {
                return <Typography variant={'caption'}>{isValid(rowData.Width) ? rowData.Width : translations['short_not_assigned'] || 'n/a'}</Typography>;
            }
        },
        {
            title: translations["height"] || 'Height', field: 'Height',
            hidden: visible ? visible['Height'] : false,
            filtering: true,
            render: rowData => {
                return <Typography variant={'caption'}>{isValid(rowData.Height) ? rowData.Height : translations['short_not_assigned'] || 'n/a'}</Typography>;
            }
        },
        {
            title: translations["length"] || 'Length', field: 'Length',
            hidden: visible ? visible['Length'] : false,
            filtering: true,
            render: rowData => {
                return <Typography variant={'caption'}>{isValid(rowData.Length) ? rowData.Length : translations['short_not_assigned'] || 'n/a'}</Typography>;
            }
        },
        {
            title: translations["max_weight"] || 'Max weight', field: 'MaxWeight',
            hidden: visible ? visible['MaxWeight'] : false,
            filtering: true,
            render: rowData => {
                return <Typography variant={'caption'}>{isValid(rowData.MaxWeight) ? rowData.MaxWeight : translations['short_not_assigned'] || 'n/a'}</Typography>;
            }
        },
        {
            title: translations["without_holder_colli"] || 'Allow having no holder', field: 'AllowHolderColliIDNull',
            hidden: visible ? visible['AllowHolderColliIDNull'] : false,
            lookup: { '0': translations['no'] || 'No', '1': translations['yes'] || 'Yes' },
            defaultFilter: ['0', '1'],
            render: rowData => {
                return <Typography variant={'caption'}>{rowData.AllowHolderColliIDNull ? translations['yes'] || 'Yes' : translations['no'] || 'No'}</Typography>;
            }
        }
    ];

    if (!hasAtLeastOnePermission(permissions, [
        "colli_type_load"
    ])) {
        tableColumns.shift();
    }
    const redirectHandler = (path, search) => {
        createHistory();
        setRedirectOptions({ redirect: true, redirectPath: path, search: search, warehouseID: { ...warehouseObj, WarehouseInventoryID: searchParams?.WarehouseInventoryID } })
    };

    if (redirectOptions.redirect) {
        return <Redirect to={{
            pathname: redirectOptions.redirectPath,
            search: redirectOptions.search,
            state: redirectOptions.warehouseID
        }} />;
    }

    return (
        <div className={classes.root}>
            {hasPermission(permissions, 'colli_type_list') ?
                <ColliTypeList
                    warehouseObj={warehouseObj}
                    tableColumns={tableColumns}
                    redirectHandler={redirectHandler}
                    tableRef={tableRef}
                />
                :
                null}
        </div>
    );
};

const mapStateToProps = state => {
    return {
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
        columns: state.core.login.userSettings ? state.core.login.userSettings.Columns : null,
        permissions: state?.core?.login?.permissions || []
    };
};

export default connect(
    mapStateToProps,
    null
)(withStyles(styles)(ColliType));
